import { useCallback, useState } from "react";
import { TFuncaoFinanceiro } from "../../../../../types/api/financeiro/funcoes-financeiro";
import DialogCriacaoEditFuncoes from "./DialogCriacaoEditFuncoes";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function Funcoes() {

    const [openModal, setOpenModal] = useState<TOpenModalFuncoesFinanceiras>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TFuncaoFinanceiro | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<TFuncaoFinanceiro>
                titulo="Funções financeiras"
                endpoints={{
                    listar: "financeiro/configuracoes/pesquisar-funcoes",
                    deletar: "financeiro/configuracoes/excluir-funcao",
                }}
                colunas={colunas}
                queryKey="pesquisar-funcoes"
                onEditar={(funcao) => {
                    handleModalAction("open", funcao.id, funcao)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Função deletada com sucesso!"
                mensagemErroDeletar="Erro ao deletar função!"
                mensagemSemDados="Nenhuma função encontrada."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditFuncoes
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModalFuncoesFinanceiras = {
    open: number | boolean | null;
    defaultValue: TFuncaoFinanceiro | null;
} | null

const colunas: ConfiguracaoColunas<TFuncaoFinanceiro>[] = [
    {
        campo: "id",
        titulo: "Código",
    },
    {
        campo: "nome",
        titulo: "Nome",
    }
];

